import { FC, useState } from 'react'
import classes from './metaCoverageBanner.module.scss'

export const MetaCoverageBanner: FC = () => {
  const [open, setOpen] = useState(false)

  return (
    <div className={classes.banner}>
      <button
        aria-expanded={open}
        className={classes.header}
        onClick={() => setOpen((v) => !v)}
        type="button"
      >
        <span className={classes.headerLeft}>
          <svg
            className={classes.infoIcon}
            fill="none"
            height="18"
            viewBox="0 0 24 24"
            width="18"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="9"
              stroke="currentColor"
              strokeWidth="1.5"
            />
            <path
              d="M12 11v5"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
            <circle cx="12" cy="8" fill="currentColor" r="1" />
          </svg>
          Meta API Coverage &amp; Limitations
        </span>
        <svg
          className={classes.chevron}
          fill="none"
          height="20"
          style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}
          viewBox="0 0 24 24"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9l6 6 6-6"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </svg>
      </button>

      {open && (
        <div className={classes.body}>
          <p>
            Meta Ad Library data availability is determined by Meta&apos;s
            public API policies and regional transparency regulations.
          </p>
          <p>
            Commercial ads are broadly accessible only when campaigns are
            delivered to supported EU/EEA/UK regions. Advertisers targeting
            unsupported regions may return partial or empty results unless ads
            are classified as Political or Social Issue content.
          </p>
          <p>
            Supported commercial coverage regions: EU 27 + EEA (IS, NO, LI) + UK
            + Switzerland.
          </p>
          <p>
            For unsupported regions (including GE, TR, US, BR, IN, JP and
            others), only Political/Social Issue ads and EU-targeted ads may be
            publicly accessible.
          </p>
          <p className={classes.subheading}>Additional limitations:</p>
          <ul className={classes.list}>
            <li>Political/Social Issue ads retain up to 7 years of history</li>
            <li>Commercial ads retain up to 1 year of history</li>
            <li>
              Spend and impression data are primarily available for
              Political/Social Issue ads
            </li>
            <li>No creative previews available</li>
            <li>
              Certain regulated categories have additional regional restrictions
            </li>
            <li>
              Russia political advertising returns no results due to Meta policy
              restrictions
            </li>
          </ul>
        </div>
      )}
    </div>
  )
}
